module.exports = __webpack_public_path__ + "static/assets/9d83423f7375689e3a1ba207d5bda74b.svg";